module.exports = __webpack_public_path__ + "9d41fee6b78c1d6230926f2d617f87ab.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/ja.json
// module id = 1158
// module chunks = 0